/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
 import { DndProvider } from 'react-dnd'
 import { HTML5Backend } from 'react-dnd-html5-backend'
 
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import App from "./app/App";
import "./index.scss"; // Standard version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";

// Datepicker
import "react-datepicker/dist/react-datepicker.css";

import "./app/assets/site.css";

import "leaflet/dist/leaflet.css";

import {
  MaterialThemeProvider,
  MetronicLayoutProvider,
  //MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout";
import {MetronicI18nProvider} from "./_metronic/i18n";


ReactDOM.render(
  <DndProvider backend={HTML5Backend}>
      <MaterialThemeProvider>
        <MetronicI18nProvider>
          <MetronicLayoutProvider>
            <MetronicSubheaderProvider>
              <App basename={window.config.ROUTER_APP_NAME}  />
            </MetronicSubheaderProvider>
          </MetronicLayoutProvider>
        </MetronicI18nProvider>
      </MaterialThemeProvider>
    </DndProvider>,
  document.getElementById("root")
);